import Box from '@fuegokit/react/components/Box'
import React from 'react'

export interface CounterProps {
  children?: React.ReactNode
}

export const Counter = ({children, ...props}: CounterProps) => {
  return <Box>{children}</Box>
}

Counter.displayName = 'Count'
